export default __webpack_public_path__ + "static/media/gold-card.05bf83d6.jpeg";